import React from "react"
import { AlertCircle, CheckCircle2, Clock, CircleDashed } from "lucide-react"
import { getInvoiceStatusConfig } from "./invoiceUtils.ts"

type InvoiceStatusBadgeProps = {
  status: string
}

const STATUS_ICONS: Record<string, React.ElementType> = {
  paid: CheckCircle2,
  pending: Clock,
  overdue: AlertCircle,
  partially_paid: CircleDashed,
}

export function InvoiceStatusBadge({ status }: InvoiceStatusBadgeProps) {
  const config = getInvoiceStatusConfig(status)
  const Icon = STATUS_ICONS[status.toLowerCase()] || CircleDashed

  return (
    <span
      className={`inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-[11px] font-bold border ${config.bg} ${config.text} ${config.border}`}
    >
      <Icon className="h-3 w-3 shrink-0" aria-hidden />
      {config.label}
    </span>
  )
}
